export class TrackingEvent extends Event {
    constructor(eventName, eventInitDict) {
        super(eventName);
        this.detail = eventInitDict.detail;
    }
}
//# sourceMappingURL=TrackingEvent.js.map